module.exports = __webpack_public_path__ + "img/img-title2.963aae75.png";